import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Card from '../../Cards/Card';
import Image from '../../../Core/Image';

export const Heading = styled.h2`
  font-size: 1.375rem;
  line-height: 130%;
  color: ${({ headingColor }) =>
    headingColor
      ? themeGet(`colors.${headingColor}`)
      : themeGet('colors.main-text')};
  text-align: ${({ contentAlignment }) => contentAlignment || 'left'};

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    font-size: 2.25rem;
    line-height: 130%;
  }
`;

export const Subheading = styled.p`
  margin-top: 1.5rem;
  font-size: 1.125rem;
  line-height: 1.875rem;
`;

export const ContentWrapper = styled.div`
  .swiper {
    .swiper-button-next {
      right: -24px;
    }

    .swiper-button-prev {
      left: -24px;
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding-bottom: 2rem;
    padding-top: 2rem;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
`;

export const StyledCard = styled(Card)`
  position: relative;
  height: 100%;
  width: 100%;
  border-radius: 0.75rem;
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 1rem 0;
  position: relative;
  z-index: 2;
`;

export const OverflowContainer = styled.div`
  overflow-x: hidden;
  margin: 40px auto;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 70px auto;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    margin: 100px auto;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: ${({ hasImg }) => (hasImg ? '50%' : '100%')};
  }
`;

export const OverflowHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 1.5rem;
  }
`;

export const StyledImage = styled(Image)`
  max-width: 100%;
  max-height: 8.5rem;
  align-self: center;
  margin-top: 1.5rem;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    max-width: 45%;
    margin-top: unset;
  }
`;
